// moood-pdf.js — Génération fiche PDF configurateur moood
// Fichier JS séparé pour éviter le parsing Liquid

function genererPDF() {
  var state = window.mooodState;
  var getTunnel = window.mooodGetTunnel;
  var formatPrice = window.mooodFormatPrice;
  if (!state || !getTunnel || !formatPrice) {
    alert("Erreur: configurateur non initialisé.");
    return;
  }

  var d = new Date();
  var date = d.toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" });
  var tunnel = getTunnel();

  // Grouper par couleur puis collection
  var couleursOrder = [];
  var byColor = {};
  for (var i = 0; i < state.panier.length; i++) {
    var item = state.panier[i];
    var color = item.color || "Sans couleur";
    if (!byColor[color]) { byColor[color] = {}; couleursOrder.push(color); }
    if (!byColor[color][item.collection]) byColor[color][item.collection] = [];
    byColor[color][item.collection].push(item);
  }

  var totalGeneral = state.panier.reduce(function(s, i) { return s + i.price * i.qty; }, 0);
  var totalQty = state.panier.reduce(function(s, i) { return s + i.qty; }, 0);

  // Construire HTML des sections couleurs
  var sectionsHTML = "";
  for (var ci = 0; ci < couleursOrder.length; ci++) {
    var color = couleursOrder[ci];
    var swatch = state.allCouleurs.find(function(s) { return s.name === color; });
    var bg = swatch && swatch.swatchImage
      ? "background-image:url(" + swatch.swatchImage + ");background-size:cover;"
      : "background:" + (swatch && swatch.swatchColor ? swatch.swatchColor : "#e5e7eb") + ";";

    var colorTotal = 0;
    var colsHTML = "";
    var colHandles = Object.keys(byColor[color]);
    for (var ki = 0; ki < colHandles.length; ki++) {
      var colHandle = colHandles[ki];
      var items = byColor[color][colHandle];
      var colObj = tunnel.find(function(c) { return c.handle === colHandle; });
      var colQty = items.reduce(function(s, i) { return s + i.qty; }, 0);
      var label = colObj ? colObj.title : colHandle;
      colsHTML += "<div style=\"font-size:11px;font-weight:600;color:#9ca3af;text-transform:uppercase;letter-spacing:.06em;padding:8px 16px 4px;\">" + label + " <span style=\"background:#12433D;color:#fff;border-radius:50%;padding:1px 5px;font-size:10px;\">" + colQty + "</span></div>";
      colsHTML += "<table style=\"width:100%;border-collapse:collapse;\"><tbody>";
      for (var ii = 0; ii < items.length; ii++) {
        var it = items[ii];
        colorTotal += it.price * it.qty;
        var dims = "";
        if (it.surMesureProps) {
          dims = "<br><small style=\"color:#6b7280;\">" + it.surMesureProps.largeur + "x" + it.surMesureProps.longueur + "mm";
          if (it.surMesureProps.options) {
            for (var oi = 0; oi < it.surMesureProps.options.length; oi++) {
              dims += " · " + it.surMesureProps.options[oi].valeur;
            }
          }
          dims += "</small>";
        }
        colsHTML += "<tr style=\"border-bottom:1px solid #f3f4f6;\">";
        colsHTML += "<td style=\"width:52px;padding:8px 8px 8px 16px;\"><img src=\"" + it.image + "\" style=\"width:40px;height:40px;object-fit:cover;border-radius:6px;\" /></td>";
        colsHTML += "<td style=\"padding:8px;font-size:13px;font-weight:500;\">" + it.name + dims + "</td>";
        colsHTML += "<td style=\"padding:8px;font-size:13px;color:#6b7280;\">x" + it.qty + "</td>";
        colsHTML += "<td style=\"padding:8px 16px 8px 8px;font-size:13px;font-weight:600;color:#12433D;text-align:right;\">" + formatPrice(it.price * it.qty) + "</td>";
        colsHTML += "</tr>";
      }
      colsHTML += "</tbody></table>";
    }

    var colorQty = Object.values(byColor[color]).flat().reduce(function(s, i) { return s + i.qty; }, 0);
    sectionsHTML += "<div style=\"margin-bottom:24px;border:1px solid #e5e7eb;border-radius:12px;overflow:hidden;\">";
    sectionsHTML += "<div style=\"display:flex;align-items:center;gap:10px;background:#f9fafb;padding:12px 16px;border-bottom:1px solid #e5e7eb;\">";
    sectionsHTML += "<span style=\"width:20px;height:20px;border-radius:50%;flex-shrink:0;clip-path:circle(50%);display:inline-block;" + bg + "\"></span>";
    sectionsHTML += "<span style=\"font-size:15px;font-weight:700;color:#12433D;flex:1;\">" + color + "</span>";
    sectionsHTML += "<span style=\"font-size:13px;color:#6b7280;\">" + colorQty + " produit" + (colorQty > 1 ? "s" : "") + " &mdash; " + formatPrice(colorTotal) + "</span>";
    sectionsHTML += "</div>" + colsHTML + "</div>";
  }

  // Ouvrir fenêtre PDF
  var win = window.open("", "_blank");
  if (!win) { alert("Autorisez les popups pour générer le PDF."); return; }
  var doc = win.document;
  doc.open("text/html", "replace");
  doc.write("<!DOCTYPE html><html lang=fr><head><meta charset=UTF-8>");
  doc.write("<title>Ma cuisine moood</title>");
  doc.write("<style>");
  doc.write("*{box-sizing:border-box;margin:0;padding:0}");
  doc.write("body{font-family:sans-serif;color:#111827;padding:32px;max-width:900px;margin:0 auto}");
  doc.write("@media print{@page{margin:15mm}body{padding:0}}");
  doc.write("</style></head><body>");

  // Header
  doc.write("<div style='display:flex;justify-content:space-between;align-items:flex-start;border-bottom:2px solid #12433D;padding-bottom:20px;margin-bottom:28px;'>");
  doc.write("<div style='font-size:32px;font-weight:800;color:#12433D;letter-spacing:-1px;'>moood</div>");
  doc.write("<div style='text-align:right;font-size:12px;color:#6b7280;line-height:1.8;'>");
  doc.write("<div>Ma configuration cuisine</div>");
  doc.write("<div>Générée le <strong style='color:#111827;'>" + date + "</strong></div>");
  doc.write("<div><strong style='color:#111827;'>" + totalQty + " produit" + (totalQty > 1 ? "s" : "") + "</strong></div>");
  doc.write("</div></div>");

  // Résumé
  doc.write("<div style='display:flex;gap:16px;margin-bottom:28px;'>");
  doc.write("<div style='flex:1;background:#f9fafb;border-radius:12px;padding:16px;'><div style='font-size:11px;color:#6b7280;text-transform:uppercase;margin-bottom:4px;'>Coloris</div><div style='font-size:20px;font-weight:700;color:#12433D;'>" + couleursOrder.length + " couleur" + (couleursOrder.length > 1 ? "s" : "") + "</div></div>");
  doc.write("<div style='flex:1;background:#f9fafb;border-radius:12px;padding:16px;'><div style='font-size:11px;color:#6b7280;text-transform:uppercase;margin-bottom:4px;'>Produits</div><div style='font-size:20px;font-weight:700;color:#12433D;'>" + totalQty + "</div></div>");
  doc.write("<div style='flex:1;background:#f9fafb;border-radius:12px;padding:16px;'><div style='font-size:11px;color:#6b7280;text-transform:uppercase;margin-bottom:4px;'>Total estimé</div><div style='font-size:20px;font-weight:700;color:#12433D;'>" + formatPrice(totalGeneral) + "</div></div>");
  doc.write("</div>");

  // Sections
  doc.write(sectionsHTML);

  // Total
  doc.write("<div style='display:flex;justify-content:space-between;align-items:center;padding:20px 0;border-top:2px solid #12433D;margin-top:8px;'>");
  doc.write("<span style='font-size:20px;font-weight:700;color:#12433D;'>Total général</span>");
  doc.write("<span style='font-size:24px;font-weight:800;color:#12433D;'>" + formatPrice(totalGeneral) + "</span>");
  doc.write("</div>");

  // Footer
  doc.write("<div style='margin-top:32px;padding-top:16px;border-top:1px solid #e5e7eb;font-size:11px;color:#9ca3af;text-align:center;'>moood.fr &mdash; Cette fiche est une estimation. Les prix peuvent varier selon les disponibilités.</div>");
  doc.write("</body></html>");
  doc.close();
  setTimeout(function() { win.print(); }, 600);
}
